import { render, staticRenderFns } from "./Acessibilidade.vue?vue&type=template&id=7e8b8122&scoped=true"
import script from "./Acessibilidade.vue?vue&type=script&lang=js"
export * from "./Acessibilidade.vue?vue&type=script&lang=js"
import style0 from "./Acessibilidade.vue?vue&type=style&index=0&id=7e8b8122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8b8122",
  null
  
)

export default component.exports